import { EChatOnboardingActionTypes, TChatOnboardingActions } from '../../actions/chatOnboarding';
import { TChatOnboardingState } from '../../types/chatOnboarding';

const initialState = {
  builder: {
    available: false,
    onboardingText: '',
  },
};

export const chatOnboardingReducer = (
  state: TChatOnboardingState = initialState,
  action: TChatOnboardingActions,
): TChatOnboardingState => {
  switch (action.type) {
    case EChatOnboardingActionTypes.SetUnavailable:
      return {
        ...state,
        [action.payload]: {
          available: false,
          onboardingText: '',
        },
      };
    default:
      return state;
  }
};
